import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromQueryPramsActions from '../+state/actions/query-params.actions';
import { QueryParams } from '../models/states/query-params-state.interfaces';

@Injectable({ providedIn: 'root' })
export class QueryParamsFacade {
  constructor(private store: Store) {}

  storeInputValues(queryParams: QueryParams | null) {
    this.store.dispatch(
      fromQueryPramsActions.StoreQueryParamsInputValues({
        queryParams
      })
    );
  }
}
